module.exports = __webpack_public_path__ + "static/media/ptss.f0067267.png";